import { weeklySchedule } from "@/mocks/animeData";

export default function WeeklySection() {
  return (
    <section className="bg-secondary-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              追番<span className="text-primary-500">时间表</span>
            </h2>
            <p className="text-foreground-500 text-sm mt-2">每日更新番剧时间一览，再也不错过更新</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
            {weeklySchedule.map((item) => (
              <div
                key={item.day}
                className="bg-background-50 rounded-2xl p-4 text-center hover:bg-background-100 transition-colors"
              >
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary-100 text-primary-600 font-bold text-sm mb-3">
                  {item.day}
                </div>
                <div className="flex flex-col gap-1.5">
                  {item.animes.map((anime, idx) => (
                    <span
                      key={idx}
                      className="text-xs text-foreground-700 py-1 px-2 rounded-lg bg-background-100 truncate"
                    >
                      {anime}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}